import { useEffect, useState } from "react";

const useWebSocket = (url) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const socket = new WebSocket(url);

        socket.onopen = () => {
            console.log("WebSocket bağlantısı açıldı:", url);
        };

        socket.onmessage = (event) => {
            try {
                const receivedData = JSON.parse(event.data);
                setData(receivedData);
            } catch (error) {
                console.error("WebSocket mesajı JSON'a çevrilemedi:", error);
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket Hatası:", error);
        };

        return () => {
            socket.close();
        };
    }, [url]);

    return data;
};

export default useWebSocket;